/// <reference path="../../node_modules/dotvvm-types/dotvvm.d.ts" />

import { initCalendarView } from "./calendar-toggle";
import { initNav } from "./navigation";
import { ConfirmDialogPostbackHandler } from '../../Controls/PostBackHandlers/ConfirmDialogPostbackHandler';
import { initLoadingPostBackHandler } from '../../Controls/PostBackHandlers/LoadingPostBackHandler';


dotvvm.events.init.subscribe(function () {
    dotvvm.postbackHandlers["confirm-dialog"] = (options: any) => new ConfirmDialogPostbackHandler(options);
    initLoadingPostBackHandler();
    initNav();
    initCalendarView();
});

